import { useState } from "react"
import { usePost } from "../utils/apiComponent/useApi"
import { endpoints } from "../utils/endpoints"
// import { quizAttemptApiResponseSchema } from "../utils/schemas/quiz-attempt-schema" // Temporarily disabled

/**
 * Hook to submit quiz attempts
 * @param {string} quizId - The ID of the quiz
 * @returns {Object} - { submitAttempt, loading, error, result }
 */
export function useQuizAttempt(quizId) {
  const [result, setResult] = useState(null)
  
  const {
    execute: postAttempt,
    loading,
    error
  } = usePost(endpoints.quizAttempt(quizId), {
    // Temporarily disable schema validation to see raw response
    // schema: quizAttemptApiResponseSchema
  })

  const submitAttempt = async (attemptData) => {
    try {
      const response = await postAttempt(attemptData)
      console.log('📥 Réponse brute de l\'API:', response)
      setResult(response)
      return response
    } catch (err) {
      console.error('Error submitting quiz attempt:', err)
      throw err
    }
  }

  return {
    submitAttempt,
    loading,
    error,
    result
  }
}
